import { MenuItem } from "../../menu/types";

export const getFirstAvailableMenuItemPath = (menuItems: MenuItem[]) =>
  menuItems.filter((menuItem) => !menuItem.disabled && menuItem.path)[0]?.path;
